<!-- 头部导航 -->
<template>

	<div class="main" :style="{ backgroundColor: bgc }">
		<div class="head">
			<div class="h-logo" @click="nav()">
				<!-- 数通链 -->
				<img src="@/assets/images/public/NFTCN-logo.png" alt="logo" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'myNavbar',
		props: {
			activeIndex: {
				type: String,
				default: '1',
			},
			bgc: {
				type: String,
				default: '#333',
			},
		},
		data() {
			return {
				avatar: 'http://nftcn.oss-cn-shanghai.aliyuncs.com/upload/2021/10/10/11-22-NFTchina-1633860422.png',
				isShowTooltip: false,
			}
		},
		created() {
			if (localStorage.getItem('avatar') != undefined) {
				this.avatar = localStorage.getItem('avatar')
			}
			// if (localStorage.getItem('token') != undefined) {
			//     this.isShowTooltip = true
			// }
		},
		methods: {
			// 跳转导航栏各标签
			handleSelect(index) {
				if (index == '1') {
					this.$router.replace({
						name: 'index'
					})
				}
				if (index == '2') {
					this.$router.replace({
						name: 'mall'
					})
				}
				if (index == '3') {
					this.$router.replace({
						name: 'artist'
					})
				}
				if (index == '4') {
					this.$router.replace({
						name: 'collectorList'
					})
				}
				if (index == '5') {
					this.$router.replace({
						name: 'processIntroduced'
					})
				}
				if (index == '6') {
					this.$router.replace({
						name: 'aboutUs'
					})
				}
			},
			// 跳转个人中心
			toPersonalCenter() {
				this.$router.replace({
					name: 'personalCenter'
				})
			},
			// 显示头像下气泡
			showTooltip() {
				this.isShowTooltip = true
			},
			// 注销
			logout() {
				localStorage.clear()
				// this.$alert('3秒后自动前往登录页', '系统提示', {
				//     confirmButtonText: '立即前往',
				//     callback: () => {
				//         this.$router.replace({ name: 'login' })
				//     },
				// })
				// setTimeout(() => {
				//     this.$router.replace({ name: 'login' })
				// }, 3000)
				this.$router.replace({
					name: 'login'
				})
			},
			nav() {
				this.$router.push({
					name: 'index',
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	.main {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 999;
		background-color: #333;

		.head {
			width: 1200px;
			height: 70px;
			margin: 0 auto;
			padding: 0 40px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.h-logo {
				cursor: pointer;
				color: #FFF;
				font-size: 24px;
				font-weight: 600;

				img {
					width: 340px;
					height: auto;
				}
			}
		}
	}

	.tooltip-content {
		cursor: pointer;
	}
</style>
